@import 'styles/blaze/mixins';
@import 'styles/mixins';
@import 'styles/variables';

.linkList {
  @include thinScrollbar;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.navItemsList {
  margin-top: 5px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  width: 100%;

  [data-autopilot-system-redesign='on'] & {
    margin-top: 10px;
  }
}

.iconFilled {
  svg {
    display: block;
    fill: var(--light-100);
  }
}

.betaPill {
  @include sm-sohne;

  color: var(--dark-40);
  text-align: center;
  font-size: 10px;
  line-height: 139%;
  letter-spacing: 0.3px;
}
